import { PrimitiveType } from "../models";
import { parseBoolean } from "./string.helpers";

export const switchAnyValueToBool = (val: PrimitiveType): boolean => {
  return val === true || val === "on" || parseBoolean(val) || false;
};

/**
 * True when Recoil still holds another record (or a create/duplicate
 * template without id). Missing dto is not stale: first-open / 404.
 */
export const isStaleEditFormDto = ({
  requestedId,
  dtoId,
  hasDto,
}: {
  requestedId?: number;
  dtoId?: number;
  hasDto?: boolean;
}): boolean => {
  if (!requestedId) {
    return false;
  }
  if (dtoId !== undefined) {
    return dtoId !== requestedId;
  }
  return Boolean(hasDto);
};

/**
 * Duplicate/revert opens /add/:sourceId while Recoil may still hold the source
 * record. Until id is stripped, the add form has no dates and the center is blank.
 */
export const isPendingDuplicateSourceDto = ({
  idCopyFrom,
  dtoId,
}: {
  idCopyFrom?: number;
  dtoId?: number;
}): boolean => Boolean(idCopyFrom) && dtoId !== undefined;
